import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useScreenSize } from '../../hooks/useScreenSize';

interface GridSliderProps {
  children: React.ReactNode;
  slidesPerView?: number | 'auto';
  spaceBetween?: number;
  centered?: boolean;
  onReady?: (swiper: SwiperType) => void; // ADD THIS
}

const GridSlider: React.FC<GridSliderProps> = ({
  children,
  slidesPerView = 1,
  spaceBetween = 16,
  centered = false,
  onReady,
}) => {
  const items = React.Children.toArray(children);
  const prevRef = useRef<HTMLButtonElement | null>(null);
  const nextRef = useRef<HTMLButtonElement | null>(null);
  const swiperRef = useRef<SwiperType | null>(null);
  const [isAtStart, setIsAtStart] = useState(true);
  const { isTablet } = useScreenSize();

  const handleSlideChange = (swiper: SwiperType) => {
    setIsAtStart(swiper.isBeginning);
  };

  useEffect(() => {
    if (
      swiperRef.current &&
      swiperRef.current.params.navigation &&
      typeof swiperRef.current.params.navigation !== 'boolean'
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <div className="grid-slider relative">
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        centeredSlides={centered}
        pagination={{ clickable: true }}
        onSwiper={(swiper: SwiperType) => {
          swiperRef.current = swiper;
          setIsAtStart(swiper.isBeginning);

          if (onReady) onReady(swiper);
        }}
        onSlideChange={handleSlideChange}
      >
        {items.map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </Swiper>

      <div className="grid-slider-nav flex-row absolute">
        {isTablet ? (
          <>
            <button
              ref={prevRef}
              className="custom-nav-btn prev-mobile"
              aria-label="Previous slide"
            >
              SWIPE LINKS
            </button>
            <button ref={nextRef} className="custom-nav-btn next-mobile " aria-label="Next slide">
              SWIPE RECHTS
            </button>
          </>
        ) : (
          <>
            <button
              ref={prevRef}
              className={`custom-nav-btn prev ${isAtStart ? '' : 'prev-active'}`}
              aria-label="Previous slide"
              disabled={isAtStart}
            >
              {isAtStart ? (
                <p className="bold">
                  Cool by nature. <span className="color-sec">Smart by choice.</span>
                </p>
              ) : (
                'SWIPE LINKS'
              )}
            </button>

            <button ref={nextRef} className="custom-nav-btn next" aria-label="Next slide">
              SWIPE RECHTS
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default GridSlider;
